export default __webpack_public_path__ + "static/media/adatkezelesi_tajekoztato.d05b392d.pdf";